// Product tabs functionality
function initializeProductTabs() {
  const productTabsContainers = document.querySelectorAll('.product-tabs');
  
  productTabsContainers.forEach(container => {
    const tabs = container.querySelectorAll('.product-tabs__tab');
    const panels = container.querySelectorAll('.product-tabs__panel');
    
    tabs.forEach(tab => {
      tab.addEventListener('click', function(event) {
        event.preventDefault();
        
        const clickedTab = event.target;
        const targetPanel = clickedTab.getAttribute('data-tab');
        
        // Remove active class from all tabs and panels in this container
        tabs.forEach(t => t.classList.remove('product-tabs__tab--active'));
        panels.forEach(p => p.classList.remove('product-tabs__panel--active'));
        
        // Add active class to clicked tab and corresponding panel
        clickedTab.classList.add('product-tabs__tab--active');
        const targetPanelElement = container.querySelector(`[data-panel="${targetPanel}"]`);
        if (targetPanelElement) {
          targetPanelElement.classList.add('product-tabs__panel--active');
        }
      });
    });
  });
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', initializeProductTabs);

// Also initialize if content is loaded dynamically (for theme editor)
document.addEventListener('shopify:section:load', initializeProductTabs);